import {
  StyledIconButton,
  getIconColor,
  getIconSize,
} from './IconButton.styles';
import { ComponentProps } from 'react';
import { useTheme } from 'styled-components';
import { StyledIcon } from 'src/components/foundations/foundations.styles';

type IconButtonProps = ComponentProps<typeof StyledIconButton> & {
  size: 'small' | 'medium' | 'large';
  variant: 'primary' | 'secondary' | 'tertiary';
  disabled?: boolean;
  iconName: string;
  color?: string;
  circular?: boolean;
  fontSize?: string;
  noBorder?: boolean;
  'data-testid'?: string;
};

export const IconButton = ({ iconName, ...props }: IconButtonProps) => {
  const theme = useTheme();
  return (
    <StyledIconButton {...props}>
      <StyledIcon
        className={iconName}
        color={
          props.color
            ? props.color
            : getIconColor(props.variant, props.disabled, theme)
        }
        size={props.fontSize ?? getIconSize(props.size)}
      />
    </StyledIconButton>
  );
};
